import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import Icon from '../Icon';
import ConfigConsumer from '../ConfigConsumer';
import { getLocale } from '../locale';
var HIDE_CLASS = 'jmtd-time-panel-hide';

var DateTimePanel = function DateTimePanel(_ref) {
  var datePanel = _ref.datePanel,
      timePanel = _ref.timePanel,
      state = _ref.state,
      update = _ref.update;

  var onToggleClick = function onToggleClick() {
    state.showTimePanel = !state.showTimePanel;
    state.count = state.count ? ++state.count : 1;

    var _state$panelDateRef$g = state.panelDateRef.getBoundingClientRect(),
        pdHeight = _state$panelDateRef$g.height,
        pdWidth = _state$panelDateRef$g.width;

    state.panelTimeBody.classList.remove(HIDE_CLASS);

    var _state$panelTimeBody$ = state.panelTimeBody.getBoundingClientRect(),
        ptbHeight = _state$panelTimeBody$.height,
        ptWidth = _state$panelTimeBody$.width;

    var _state$panelToggle$ge = state.panelToggle.getBoundingClientRect(),
        pToggleHeight = _state$panelToggle$ge.height;

    state.pwHeight = pdHeight + pToggleHeight;
    state.pwWidth = pdWidth;

    if (state.showTimePanel) {
      update();
      setTimeout(function () {
        state.pwHeight = ptbHeight + pToggleHeight;
        state.pwWidth = ptWidth;
        state.panelTimeTop = -pdHeight + 1;
        update();
      });
    } else {
      state.panelTimeTop = 0;
      update();
      setTimeout(function () {
        state.pwHeight = undefined;
        state.panelTimeTop = undefined;
        state.panelTimeBody.classList.add(HIDE_CLASS);
        update();
      }, 300);
    }
  };

  var panelStyle = {
    height: state.pwHeight,
    width: state.pwWidth
  };
  var timePanelStyle = {
    top: state.panelTimeTop
  };
  return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (_ref2) {
    var locale = _ref2.locale;
    return /*#__PURE__*/React.createElement("div", {
      className: "jmtd-date-time-panel",
      style: panelStyle
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref3) {
        state.panelDateRef = _ref3;
      },
      className: "jmtd-date-time-date-panel"
    }, datePanel), /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref6) {
        state.panelTime = _ref6;
      },
      className: "jmtd-date-time-time-panel",
      style: timePanelStyle
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref4) {
        state.panelToggle = _ref4;
      },
      className: "jmtd-date-time-toggle",
      onClick: onToggleClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "jmtd-date-time-toggle-content"
    }, /*#__PURE__*/React.createElement(Icon, {
      fontSize: 14,
      className: state.showTimePanel ? 'jmti-calendar' : 'jmti-clock'
    }), state.showTimePanel ? getLocale(locale).datePicker.selectDate : getLocale(locale).datePicker.selectTime)), /*#__PURE__*/React.createElement("div", {
      ref: function ref(_ref5) {
        state.panelTimeBody = _ref5;
      },
      className: classNames('jmtd-date-time-time-body', _defineProperty({}, HIDE_CLASS, !state.showTimePanel && !state.count))
    }, timePanel)));
  });
};

DateTimePanel.propTypes = {
  datePanel: PropTypes.node.isRequired,
  timePanel: PropTypes.node.isRequired,
  state: PropTypes.object.isRequired,
  update: PropTypes.func.isRequired
};
export default DateTimePanel;